import { createSlice } from "@reduxjs/toolkit";

const initalEditTipsState = {
    isEditEnabled: false,
    editData:{}
}

const editTipsSlice = createSlice({
    name: 'editTips',
    initialState: initalEditTipsState,
    reducers:{
        setEditMode(state,action) {
            state.isEditEnabled = action.payload;
        },
        setEditData(state,action) {
            state.editData = action.payload;
        }
    }
});

export const editTipsActions = editTipsSlice.actions;

export default editTipsSlice.reducer;